import { motion } from 'framer-motion';

export default function FormHeader() {
  return (
    <div className="text-center mb-8">
      <motion.div 
        className="bg-white rounded-2xl p-8 shadow-lg"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl md:text-4xl font-bold text-dblue mb-2">
          Harbourside Children's Center
        </h1>
        <h2 className="text-2xl md:text-3xl font-semibold text-dblue">
          Application Form
        </h2>
      </motion.div>
    </div>
  );
}

